import type { BulkUploadResumeStatus } from '@/utils/bulkUploadResume'

const EMPTY_RESUME: BulkUploadResumeStatus = {
  files: {},
  suggestedBatchId: null,
  counts: { done: 0, retry: 0, new: 0 },
}

export function mergeResumeStatuses(parts: BulkUploadResumeStatus[]): BulkUploadResumeStatus {
  if (!parts.length) return EMPTY_RESUME
  if (parts.length === 1) return parts[0]

  const files: BulkUploadResumeStatus['files'] = {}
  const counts = { done: 0, retry: 0, new: 0 }
  const batchVotes = new Map<string, number>()

  for (const part of parts) {
    Object.assign(files, part.files)
    counts.done += part.counts.done
    counts.retry += part.counts.retry
    counts.new += part.counts.new
  }

  for (const state of Object.values(files)) {
    if (state.state === 'retry' && state.batchId) {
      batchVotes.set(state.batchId, (batchVotes.get(state.batchId) || 0) + 1)
    }
  }

  let suggestedBatchId: string | null = null
  let maxVotes = 0
  for (const [batchId, votes] of batchVotes) {
    if (votes > maxVotes) {
      maxVotes = votes
      suggestedBatchId = batchId
    }
  }

  return { files, suggestedBatchId, counts }
}

export type { BulkUploadResumeStatus }
